import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import TechStack from "@/components/site/TechStack";
import Portfolio from "@/components/site/Portfolio";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import LegalPage from "@/pages/LegalPage";
import { privacyData } from "@/pages/privacyData";
import { kvkkData } from "@/pages/kvkkData";

function Site({ lang }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider lang={lang}>
      <div className="App noise-overlay">
        <Toaster position="top-right" theme="dark" richColors />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <TechStack />
          <Portfolio />
          <Process />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site lang="tr" />} />
        <Route path="/en" element={<Site lang="en" />} />
        <Route path="/ar" element={<Site lang="ar" />} />
        <Route path="/privacy-policy" element={<LegalPage data={privacyData.tr} lang="tr" backPath="/" testId="privacy-policy-page" />} />
        <Route path="/en/privacy-policy" element={<LegalPage data={privacyData.en} lang="en" backPath="/en" testId="privacy-policy-page" />} />
        <Route path="/ar/privacy-policy" element={<LegalPage data={privacyData.ar} lang="ar" backPath="/ar" testId="privacy-policy-page" />} />
        <Route path="/kvkk" element={<LegalPage data={kvkkData} lang="tr" backPath="/" testId="kvkk-page" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
